/**
 * @generated SignedSource<<64a67db3c93279ff37639b50ced4fd7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutAddShippingAddress_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutShippingForm_viewer">;
  readonly " $fragmentType": "CheckoutAddShippingAddress_viewer";
};
export type CheckoutAddShippingAddress_viewer$key = {
  readonly " $data"?: CheckoutAddShippingAddress_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutAddShippingAddress_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutAddShippingAddress_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutShippingForm_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ef6101cede80ccbb390ba3fca6d7edfc";

export default node;
